@if (component) {
<div class="w-12 center">
    <div class="w-12 center wrap">
        <h3 class="p-a-8 h1"
            *iCms="'title' of component"
            [ngClass]="component.title_font_style || ''"></h3>
        <div class="w-12 m-b-2">
            @for (item of pages; track item; let i = $index) {
            <div class="w-3 w-6-m w-12-s m-b"
                 [ngClass]="{ 'none' : (i===2 && (client.isS || client.isM)) }">
                <div class="p-a-2 p-b-6 p-a-0-s">
                    <cms-blog-component-more-stories-item [modelId]="item.page" />
                </div>
            </div>
            }
        </div>
        @if (isBtnVisible) {
        <button [buttonStyle]="'button-1'"
                class="m-a-2"
                role="button"
                type="button"
                (click)="loadMore()">
            <span class="uppercase p2">{{'View More' | translate}}</span>
        </button>
        }
    </div>
</div>
}